import React, { useEffect } from 'react';
import clsx from 'clsx';
import InputAdornment from '@material-ui/core/InputAdornment';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';
import { checkIfEmpty, checkIfNameExists } from '../../../../../../validations/validations';
import { NameTextField } from '../../../../../../styling/Styles';
import GreyCheckBox from '../../../../../GeneralComponents/GreyCheckBox';

const AttributeTypeSelection = ({
    annotationName,
    attributeType,
    attributesTypes,
    setAttributeType,
    annotationTable,
    setAnnotationTable,
    customAttributeType,
    setCustomAttributeType,
    entities2,
    servicesNames,
    attributeTypeService,
    setAttributeTypeService,
    comp,
    setAnnotationValue,
    serviceSelectedAttr,
    setServiceSelectedAttr
  }) => {

  const [serviceSelectedAttrs, setServiceNameSelectedAttrs] = React.useState([]);

  useEffect( () => {

    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    if(attributeType === 'service'){

      const serv =  JSON.parse(localStorage.getItem('data'))[selectedProject].services[0] !== undefined && JSON.parse(localStorage.getItem('data'))[selectedProject].services[0].services_requests.filter( service => service.name === attributeTypeService).map(service => service)[0];
      const selectedService = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0] !== undefined && JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations.filter( comb => comb.annotationName === annotationName).map(comb => comb)[0];
      const selectedServiceName = selectedService !== undefined ? selectedService.attributeTypeService : '';
      const selectedServiceAttr = selectedService !== undefined ? selectedService.serviceAttr : '';

      if(serv){
        const attrs = serv.selected_inputs.map( input => input[0]);
        setServiceNameSelectedAttrs(attrs);
        if(attrs.length > 0 && attributeTypeService !== selectedServiceName) {
          setServiceSelectedAttr(attrs[0]);
        }
        else if ( attributeTypeService === selectedServiceName){
          setServiceSelectedAttr(selectedServiceAttr);
        }
      }
    }

  },[attributeTypeService,attributeType])
    
  // This functions updates the attribute type var according to the selected option
  const selectAttributeType = (option) => {
    if(option === 'radiobox' || option === 'checkbox'){
      let labelContent = '';
      try {
        labelContent = comp.view.$el[0].innerText;
      } catch (e) {
        labelContent = '';
      }
      setAnnotationValue(labelContent);
    }
    else{
      setAnnotationValue('');
    }
    setAttributeType(option);
  };

  // This function handles the annotationTable var that is responsible for the table checkbox
  const handleAnnotationTable = () => {
    if (annotationTable === true) {
      setAnnotationTable(false);
    }
    if (annotationTable === false) {
      setAnnotationTable(true);
    }
  };

  // This function handles the input value of custom attribute type
  const handleCustomAttributeTypeName = (val) => {
    setCustomAttributeType(val.target.value);
  };

  // This function handles the selection near the input of custom attribute type
  const selectEntityType = (option) => {
    setCustomAttributeType(option);
  };

  return(
    <div className={clsx('spacingTopDiv')} style={{ display: 'flex', flexDirection: 'row' }}>
    <span>
      Attribute type: <span style={{ display: 'inline-block', marginLeft: '4.2vw' }} />
    </span>
    <div className={clsx('flexProps2')} >
      
      <div 
        style={attributeType=== 'service' ?{ display: 'flex', flexDirection: 'row'}: {display: 'flex', flexDirection: 'column'}}
      >
        <span>
          <DropdownMechanism
            target={attributeType}
            targets={attributesTypes}
            selectTarget={selectAttributeType}
          />
        </span>

        {attributeType === 'entity' && 
          <AttributeTypeSelectionEntity
            customAttributeType={customAttributeType}
            attributesTypes={attributesTypes}
            entities2={entities2}
            selectEntityType={selectEntityType}
            handleCustomAttributeTypeName={handleCustomAttributeTypeName}
          />    
        }
        {attributeType === 'service' &&
          <AttributeTypeSelectionService 
            servicesNames={servicesNames}
            attributeTypeService={attributeTypeService}
            setAttributeTypeService={setAttributeTypeService}
            serviceSelectedAttrs={serviceSelectedAttrs}
            serviceSelectedAttr={serviceSelectedAttr}
            setServiceSelectedAttr={setServiceSelectedAttr}
          />

        }

      </div>
      
      <span
        className={clsx('MuiFormHelperText-root', 'Mui-error')}
        style={
          (attributeType === 'service' && attributeTypeService === 'none')  || attributeType === 'none'
            ? { display: 'inherit' }
            : { display: 'none' }
        }
      >
        { (attributeType === 'service' && attributeTypeService === 'none') ? 'Selected service none' : 'Attribute type none'}
      </span>

      <div style={{ marginTop: '1vw', display: 'flex', flexDirection: 'row' }}>
        <span  className="form-check-label" >
          table
        </span>
        <span id='tableCheckbox' style={{ marginLeft: '1vw'}}>
          <GreyCheckBox  style={{color: '#CFD8E0'}} checked={annotationTable}  onChange={handleAnnotationTable} inputProps={{ 'aria-label': 'controlled' }} />
        </span>
      </div>
    </div>
  </div>
  )
};

const AttributeTypeSelectionEntity = ({customAttributeType,attributesTypes,entities2,selectEntityType,handleCustomAttributeTypeName}) => {
  
  const getHelperText = () => {
    if( checkIfEmpty(customAttributeType) === true ){
      return 'Entity name empty';
    }
    if( checkIfNameExists(customAttributeType, attributesTypes) === true){
      return 'Predefined attribute type';
    }
    return '';
  }

  return(
    <NameTextField
        placeholder=" Entity name"
        error={
            checkIfEmpty(customAttributeType) === true ||
            checkIfNameExists(customAttributeType, attributesTypes) === true
        }
        helperText={ getHelperText()}
        InputProps={{
            endAdornment: (
            <InputAdornment position="end" className={clsx('greyLabel')}>
                <DropdownMechanism target="" targets={entities2} selectTarget={selectEntityType} />{' '}
                &nbsp;
            </InputAdornment>
            )
        }}
        onInput={(e) => handleCustomAttributeTypeName(e)}
        value={customAttributeType}
        className={clsx('greyLabel')}
        style={{ marginTop: '1vw', width: '90%' }}
    />
  )}
    
const AttributeTypeSelectionService = ({servicesNames, attributeTypeService, setAttributeTypeService, serviceSelectedAttrs,serviceSelectedAttr ,setServiceSelectedAttr}) => {

  const selectServiceTarget = (option) => {
      setAttributeTypeService(option)
  }

  const selectServiceAttrTarget = (option) => {
    setServiceSelectedAttr(option)
  }

  return(
      <>
      <span> &nbsp; : &nbsp;</span>
      <DropdownMechanism
          target={attributeTypeService}
          targets={servicesNames}
          selectTarget={ selectServiceTarget}
      />    
      { attributeTypeService !== 'none' &&
        <>
        &nbsp;
        <span> : </span>
        &nbsp;
        <DropdownMechanism
            target={serviceSelectedAttr}
            targets={serviceSelectedAttrs}
            selectTarget={selectServiceAttrTarget}
        />
        </>
      }
      </>
  )
}


export default AttributeTypeSelection;
  